import { ControlInterface } from 'edocatbase/Form';
import { Dispatch } from 'redux';
import ContactsModal from './ContactsModal';
const { toggleModal } = window.Edocat.Components.ModalTest.actions;
const { Button } = window.Material;

interface TextFieldInterface extends ControlInterface {
	multiline: boolean;
	actions: any;
	formInstanceId: string;
	contactsModal: any;
	view: boolean;
}

// @ts-ignore
class AresField extends window.React.PureComponent<TextFieldInterface> {
	handleContacts = (index: number) => {
		const { actions, formInstanceId, name } = this.props;
		actions.toggleModal(true, name, { index }, formInstanceId);
	};

	render() {
		const { value, contactsModal, formInstanceId, name, view, className } = this.props;
		return value?.map((it: any, index: number) => (
			<div className="aresCompanySet--View" key={index}>
				{Object.keys(it).map((item: string, innerIndex: number) =>
					item !== 'contacts' && item !== 'aresError' ? (
						<div className={`form-row row-${name} simple-row`} key={`${index}${innerIndex}`}>
							<label>{window.Alfresco.messages.global[`edocat.forms.${item}`]}</label>
							<div
								id={name}
								dangerouslySetInnerHTML={{
									__html: it?.[item] || it?.[item] === 0 ? it?.[item] : window.Alfresco.messages.global['label.none'],
								}}
							/>
						</div>
					) : null
				)}
				<div className={`form-row row-${name} simple-row`}>
					<label>Kontakty</label>
					<div>
						<Button variant="outlined" onClick={() => this.handleContacts(index)} size="small">
							Zobrazit tabulku
						</Button>
					</div>
				</div>
				{contactsModal.isOpen && (
					<ContactsModal
						{...{ index: contactsModal?.items?.index, name, value, contactsModal, view, formInstanceId }}
					/>
				)}
			</div>
		));
	}
}

const mapStateToProps = (state: any, props: any) => {
	const contactsModal = state?.[props.formInstanceId]?.formModal?.[props.name] || {};
	return {
		contactsModal,
	};
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
	actions: window.redux.bindActionCreators({ toggleModal }, dispatch),
});

export default window.reactRedux.connect(mapStateToProps, mapDispatchToProps)(AresField);
